import { kebabCase } from '../../utils/lodash-replacements';

export default () => {
  // Trigger custom events
  document.dispatchEvent(new CustomEvent('shoppableImageWillOpen'));

  const modal = document.querySelector('[data-shoppable-image-modal]');

  // Add classes to elements with the 'data-state' attribute
  document.querySelectorAll('[data-state]').forEach((element) => {
    element.classList.add('State--modal-open', 'State--shoppable-image-open');
  });

  // Add classes to the modal
  modal.classList.add('ShoppableModal--Active', 'Modal--open', 'Animate', 'Animate--slide-left', 'Animate--animated');

  // Handle color selector options
  const colorSelector = document.querySelector('[data-color-selector]');
  if (colorSelector) {
    const options = colorSelector.querySelectorAll('option');
    options.forEach((option) => {
      const value = option.value;
      const text = option.textContent;
      if (value) {
        const colorSwatch = document.createElement('div');
        colorSwatch.innerHTML = `
          <span class="color isp-product-color-swatch isp-product-color-swatch-${kebabCase(
            value,
          )}" data-sticky-color-variant-selectordata-value="${value}"></span>
          <div>${text}</div>
        `;
        option.innerHTML = colorSwatch.outerHTML;
      }
    });
  }

  // Handle size selector options
  const sizeSelector = document.querySelector('[data-size-selector]');
  if (sizeSelector) {
    const options = sizeSelector.querySelectorAll('option');
    options.forEach((option) => {
      const text = option.textContent;
      option.innerHTML = text;
    });
  }

  // Trigger custom events
  document.dispatchEvent(new Event('scroll'));
  document.dispatchEvent(new CustomEvent('shoppableImageDidOpen'));
};
